import { getRoomPriceRange } from './getRoomPriceRange';

export const getRoomsPriceRange = (roomTypes, currencyInfo) =>
  Object.fromEntries(
    Object.entries(roomTypes).map(([id, roomType]) => [id, getRoomPriceRange(roomType, currencyInfo)]),
  );
